// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconAddContactPath = 'M7.465 4.586a2.536 2.536 0 1 1 5.07 0 2.536 2.536 0 0 1-5.07 0ZM10 .05a4.536 4.536 0 0 0-3.564 7.341 8 8 0 0 0-4.426 7.16v5.441h9.098v-2H4.01v-3.44a6.005 6.005 0 0 1 4.297-5.757c.523.21 1.095.326 1.693.326.602 0 1.177-.117 1.703-.33a5.995 5.995 0 0 1 2.87 1.86l1.519-1.301a8.029 8.029 0 0 0-2.521-1.967A4.536 4.536 0 0 0 10 .05Zm4.896 16.843V20h2v-3.107H20v-2h-3.104v-3.107h-2v3.107h-3.11v2h3.11Z';
var IconAddContact = baseIcon('IconAddContact', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconAddContactPath
});
export default IconAddContact;
//# sourceMappingURL=index.js.map